export default __webpack_public_path__ + "static/media/content-deco-2.d9864c70.webp";